import { IsNotNull } from "./type-safe-helpers";

export function IsEqualNumber(value1: number, value2: number): boolean {
    return (IsNotNull(value1) && IsNotNull(value2) && value1 == value2);
}

export function IsNumeric(value: string): boolean {
    return /^-{0,1}\d+$/.test(value);
}

export function IsNotNumeric(value: string): boolean {
    return IsNumeric(value) == false;
}

export function ThousandsSeperator(value: number): string {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
